import { render, staticRenderFns } from "./IconGlobe.vue?vue&type=template&id=fe114386&scoped=true&"
import script from "./IconGlobe.vue?vue&type=script&lang=ts&"
export * from "./IconGlobe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe114386",
  null
  
)

export default component.exports